import { useEffect, type ReactNode } from "react";
import { useAuth } from "./AuthContext";
import { allowAutomaticLogin, startLogin } from "./session";

let redirecting = false;
export function AuthGuard({ children }: { children: ReactNode }) {
  const { user, loading, error, reload } = useAuth();
  useEffect(() => {
    if (!loading && !user && !error && !redirecting && allowAutomaticLogin()) { redirecting = true; startLogin(); }
  }, [user, loading, error]);
  if (error) return <div className="page"><p role="alert">{error}</p><button onClick={() => void reload()}>Повторить проверку</button> <a href="/login">Перейти ко входу</a></div>;
  if (loading || !user) return <div className="page"><p className="muted">Проверяем вход…</p></div>;
  return <>{children}</>;
}
